import { PlayCircle, Coins, Clock, ListChecks } from "lucide-react";
import { t } from "@/i18n";

/* Écran affiché avant de lancer la séance : on voit clairement combien
   d'exercices attendent, combien de dinars sont gagnables au total, et le
   temps estimé — pour ne jamais se lancer à l'aveugle. */
export default function DailyPlanIntro({ plan, resuming, onStart }) {
  const items = plan.items || [];
  const totalDinars =
    50 +
    items.reduce((sum, it) => {
      if (it.type === "lesson")
        return sum + 30 + (it.block?.questions?.length || 0) * 1;
      return sum + (it.questions?.length || 0) * 1;
    }, 0);

  return (
    <div className="max-w-md mx-auto text-center py-10">
      <ListChecks size={48} className="mx-auto mb-4 text-primary" />
      <h1 className="font-head text-2xl font-bold mb-2">
        {resuming ? t("dailyplanintro.reprendre_ta_seance") : t("dailyplanintro.seance_du_jour")}
      </h1>
      <p className="text-muted-foreground mb-6">
        {items.length} exercice{items.length > 1 ? "s" : ""} {t("dailyplanintro.environ")}{" "}
        {plan.estimated_minutes} min
      </p>
      <div className="flex justify-center gap-6 mb-8">
        <div className="flex items-center gap-1.5 text-amber-600 font-bold">
          <Coins size={18} /> {t("dailyplanintro.jusqu_a")} {totalDinars} 🪙
        </div>
        <div className="flex items-center gap-1.5 text-muted-foreground font-semibold">
          <Clock size={18} /> {plan.estimated_minutes} min
        </div>
      </div>
      <button
        onClick={onStart}
        className="w-full py-4 rounded-2xl bg-primary text-primary-foreground font-bold flex items-center justify-center gap-2"
      >
        <PlayCircle size={20} /> {resuming ? t("dailyplanintro.continuer") : t("dailyplanintro.commencer")}
      </button>
    </div>
  );
}
